document.addEventListener('DOMContentLoaded', function () {
  // Hide the field group label
  document.querySelectorAll('.field-group-format-toggler').forEach(function(element) {
    element.style.display = 'none';
  });

  document.querySelector('.field-group-format-toggler:first-child')
      .parentElement.classList.add('faq-first-article');

  // Add click event listener to all questions
  let firstExecution = true;
  document.querySelectorAll('.faq.class_accordion.field-group-format-wrapper article h2')
    .forEach(function(pergunta) {
    pergunta.addEventListener('click', function(event) {
      // Prevent default event behavior
      event.preventDefault();

      // Find the corresponding answer
      const resposta = this.parentNode.querySelector('.faq.class_accordion.field-group-format-wrapper div');

      // Show or hide the answer with animation
      if (resposta.style.display === 'none') {
        slideDown(resposta);
      } else {
        if (firstExecution) {
          firstExecution = false;
          return;
        }
        slideUp(resposta);
      }
    });
  });

  closeAllFaqs();

  function closeAllFaqs() {
    document.querySelectorAll('.faq.class_accordion.field-group-format-wrapper article .faq.class_accordion')
      .forEach(function(resposta) {
      slideUp(resposta);
    });
  }

  function slideUp(element) {
    element.style.transition = 'height 0.5s, padding 0.5s';
    element.style.height = element.scrollHeight + 'px';
    element.style.overflow = 'hidden';
    setTimeout(() => {
      element.style.height = '0';
      element.style.padding = '0';
    }, 10);
    setTimeout(() => {
      element.style.display = 'none';
    }, 510);
  }

  function slideDown(element) {
    element.style.display = 'block';
    let height = element.scrollHeight + 'px';
    element.style.height = '0';
    element.style.padding = '';
    element.style.overflow = 'hidden';
    setTimeout(() => {
      element.style.transition = 'height 0.5s, padding 0.5s';
      element.style.height = height;
    }, 10);
    setTimeout(() => {
      element.style.height = '';
      element.style.overflow = '';
    }, 510);
  }
});
